import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Navigation';
import { CheckCircle } from 'lucide-react';
import {useNavigate} from "react-router-dom";

export const CTA: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const features = [
    t('cta.features.realtime'),
    t('cta.features.setup'),
    t('cta.features.fullAccess'),
    t('cta.features.cancel')
  ];

  return (
    <section className="py-16 md:py-20 bg-indigo-600">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 leading-tight">
              {t('cta.title')}
            </h2>
            <p className="text-indigo-100 text-lg mb-6">
              {t('cta.subTitle')}
            </p>
            
            <div className="space-y-3">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-indigo-200 mr-2 flex-shrink-0" />
                  <span className="text-indigo-100">{feature}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="md:w-5/12">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('cta.form.title')}
              </h3>
              <form className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    {t('cta.form.nameLabel')}
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder={t('cta.form.namePlaceholder')}
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    {t('cta.form.emailLabel')}
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder={t('cta.form.emailPlaceholder')}
                  />
                </div>
                <Button primary
                        className="w-full py-3 text-base font-medium mt-2"
                        onClick={() => navigate('/login')}
                >
                  {t('cta.form.submit')}
                </Button>
                {/*<p className="text-xs text-gray-500 text-center mt-3">*/}
                {/*  By signing up, you agree to our{' '}*/}
                {/*  <a href="#" className="text-indigo-600 hover:text-indigo-500">*/}
                {/*    Terms of Service*/}
                {/*  </a>{' '}*/}
                {/*  and{' '}*/}
                {/*  <a href="#" className="text-indigo-600 hover:text-indigo-500">*/}
                {/*    Privacy Policy*/}
                {/*  </a>*/}
                {/*</p>*/}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
